<app-alert></app-alert>

<div class="top-div">
  <div class="title-div">Failed Email Notifictions Report</div>
  <div>From Date :
  <kendo-datepicker [min]="earliestDate" [max]="latestDate" [value]="initialFilterStartDate" (valueChange)="onStartDateChange($event)"></kendo-datepicker></div>
</div>
<div class="build-button">
  <button class="k-button cvt-primary " (click)="onBuildReport()">Build Report</button>
</div>

